export default __webpack_public_path__ + "static/media/frakt-apes-final.fccf3a9b.webp";